import { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import { Card } from '@savgroup-front-common/core/atoms/Cards';

import { CustomerCommentDisplay } from '../../../../../components/CustomerCommentDisplay';
import { ActionLabel } from '../ActionLabel';

import messages from './messages';

interface StatusWarningDisplayProps {
  adaptedFirstAction?: { toCustomerComment?: string };
}

const StatusWarningDisplay: FunctionComponent<StatusWarningDisplayProps> = ({
  adaptedFirstAction,
}) => {
  return (
    <>
      <ActionLabel action={adaptedFirstAction} index={0} />

      <CustomerCommentDisplay action={adaptedFirstAction} />

      <Card>
        <FormattedMessage {...messages.statusWarning} />
      </Card>
    </>
  );
};

StatusWarningDisplay.displayName = 'StatusWarningDisplay';

export default StatusWarningDisplay;
